import * as React from "react";
import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";
import Image from "next/image";

export interface LogoProps extends Omit<ComponentProps<"div">, "children"> {
  image?: {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
  } | null;
  backgroundColor?: "default" | "none";
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({
  image,
  backgroundColor = "default",
  onClick,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        "uipm:p-[var(--padding-padding-default)] uipm:h-[132px] uipm:rounded-[var(--radius-lg)] uipm:flex uipm:items-center uipm:justify-center",
        backgroundColor === "default" &&
          "uipm:bg-[var(--surface-surface-secondary)]",
        backgroundColor === "none" && "uipm:bg-transparent",
        onClick && "uipm:cursor-pointer",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {image && (
        <Image
          src={image.src}
          alt={image.alt || ""}
          width={image.width || 200}
          height={image.height || 80}
          className="uipm:max-w-full uipm:max-h-full uipm:object-contain"
        />
      )}
    </div>
  );
};
